// Overtime counting rule (same as the server)
export const OT_RULE =
  "Under 30 min is not overtime; 30–59 min counts as 30; from 1 hour every minute counts.";

/** Minutes that count as overtime (same rule as the server). */
export const countedMinutes = (minutes) => {
  const m = Number(minutes) || 0;
  if (m < 30) return 0;
  if (m < 60) return 30;
  return m;
};
export const formatMinutes = (m) => {
  if (m === null || m === undefined) return "—";
  const h = Math.floor(m / 60);
  const min = Math.round(m % 60);
  return h ? `${h}h ${String(min).padStart(2, "0")}m` : `${min}m`;
};

/** Minutes from "HH:mm" to "HH:mm"; an end at or before the start runs past midnight. */
export const minutesBetween = (start, end) => {
  if (!start || !end) return 0;
  const toMin = (t) => Number(t.slice(0, 2)) * 60 + Number(t.slice(3, 5));
  const diff = toMin(end) - toMin(start);
  return diff > 0 ? diff : diff + 24 * 60;
};

/** "YYYY-MM-DD" + "HH:mm" (Manila) -> ISO with +08:00; nextDay adds a day. */
export const manilaIso = (date, time, nextDay = false) => {
  let d = date;
  if (nextDay) {
    const [y, m, day] = date.split("-").map(Number);
    d = new Date(Date.UTC(y, m - 1, day + 1)).toISOString().slice(0, 10);
  }
  return `${d}T${time}:00+08:00`;
};
